import { Product, ProductPriceLocale } from "../appData/productData"

export function formatCurrency(
  value: number,
  locale: ProductPriceLocale | undefined,
) {
  const language = locale?.language ?? "en"
  const currency = locale?.currency ?? "USD"

  const formatter = Intl.NumberFormat(language, {
    style: "currency",
    currency,
  })

  let floored = Math.round(value * 100)

  if (floored % 100 == 0 && floored > 0) {
    floored -= 1
  }

  return formatter.format(floored / 100)
}

export function formatProductPrice(product: Product) {
  return formatCurrency(product.price, product.priceLocale)
}

export function isBanner() {
  const path = window.location.pathname

  return path.includes("/banner")
}

export function isPromo() {
  const path = window.location.pathname

  return (
    path.includes("/promo") ||
    path.includes("/blackFriday") ||
    path.includes("/backupPaywall")
  )
}
